<template lang="pug">
.flow#flow
  h2.l-container.is-lg
    | FLOW
    span 受講までの流れ
  ol.l-container.is-md
    li(v-for="list in getList()" :key="list.id")
      .flow-no(:class="{'is-mg' : isMg }")
        | {{ zeroPadding(list.id)}}
      .flow-title(v-html="list.title")
      .flow-description(v-html="list.description")
</template>

<script>
export default {
  props: {
    current: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isMg: false,
      flow_lists_motiongraphics: [
        {
          id: '1',
          title: 'オンライン相談会へ申し込み（または資料請求）',
          description:
            '事前に受講の流れを理解いただけると入校後の学習がスムーズに進むため、オンライン相談会に参加することを推奨しております。<br><span>※オンライン相談会は、「<a href="https://forms.vook.vc/vook/form/Untitled7/formperma/j_ZUYsupouuLJMCAAmMyFKrnWMSRPQphIUxLVCF9N6U" class="external_link" id="school_mgc_individual_reservation">オンライン相談会を予約する</a>」よりお申し込みください。</span>'
        },
        {
          id: '2',
          title: 'お申し込み/決済',
          description:
            'オンライン相談会（または資料請求）後、メールにてご案内する入会お申し込みページよりお申し込みください。<br><span>※プランのお申し込みには、Vook会員登録が必要です。</span>'
        },
        {
          id: '3',
          title: '入校フォーム',
          description:
            'お申し込み、決済が完了すると、入校フォームが記載されたメールを送信いたしますので、入校フォームに回答してください。'
        },
        {
          id: '4',
          title: 'Discord招待',
          description:
            '決済確認後、入校フォーム内に、Discordへの案内がございますので、指示に沿って参加してください。'
        },
        {
          id: '5',
          title: '学習スタート',
          description:
            '入校フォームへの回答、Discordへの参加が確認できましたら、指定の日程より学習がスタートします。'
        }
      ]
    }
  },
  mounted() {
    this.setCourse()
  },
  methods: {
    setCourse() {
      if (this.current === 'motiongraphics') {
        this.isMg = true
      }
    },
    getList() {
      if (this.current === 'motiongraphics') {
        return this.flow_lists_motiongraphics
      }
    },
    zeroPadding(num) {
      if (num < 10) {
        num = '0' + num
      }
      return num
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~/assets/css/individual/school/school2023.scss';
.flow {
  padding: 100px 0;
  @include media(sp) {
    padding: 50px 0;
  }
  h2 {
    margin-bottom: 50px;
  }
  ol {
    &.l-container {
      @include media(sp) {
        overflow: visible;
      }
    }
    li {
      background: #fff;
      padding: 30px 30px 30px 90px;
      position: relative;
      @include media(sp) {
        padding: 20px 30px 30px 0px;
      }
    }
    li + li {
      margin-top: 40px;
      &:before {
        content: '';
        width: 50px;
        height: 20px;
        position: absolute;
        background: url(~assets/images/school/flow/flow-arrow.png) center /
          contain no-repeat;
        top: -30px;
        left: calc(50% - 25px);
      }
    }
  }
  &-no {
    position: absolute;
    text-align: center;
    @include school-vg-gradation;
    font-weight: bold;
    letter-spacing: 0.1em;
    &.is-mg {
      @include school-mg-gradation;
    }
    @include media(pc) {
      top: -10px;
      left: -10px;
      width: 68px;
      height: 68px;
      line-height: 68px;
      font-size: 32px;
    }
    @include media(sp) {
      top: -5px;
      left: -5px;
      width: 50px;
      height: 50px;
      line-height: 50px;
      font-size: 24px;
    }
  }
  &-title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.1em;
    margin-bottom: 20px;
    @include media(sp) {
      padding-left: 60px;
      line-height: 1.2em;
      margin-bottom: 16px;
    }
  }
  &-description {
    line-height: 2em;
    font-size: 16px;
    @include media(sp) {
      padding-left: 20px;
      line-height: 1.8em;
    }
  }
}
::v-deep {
  .flow {
    &-description {
      span {
        font-size: 14px;
        color: #777;
        display: block;
        margin-top: 10px;
        @include media(sp) {
          line-height: 1.5em;
        }
      }
    }
  }
}
</style>
